module.exports = __webpack_public_path__ + "static/photo_13-c278b4dab774d4a7f7c87c5395bb7eec.jpg";